import { Component, OnInit } from '@angular/core';
import { CoreCustomPage } from '../../shared/core-custom-page.decorator';
import { CorePageBaseComponent } from '../../shared/core-page-base.component';

@CoreCustomPage('standard-review')
@Component({
  selector: 'cu-standard-review-page',
  templateUrl: './standard-review-page.component.html'
})
export class StandardReviewPageComponent extends CorePageBaseComponent implements OnInit {
  ngOnInit() {}
}
